/**
 * tabulated.js
 * Dependencies: jQuery, Babel, gulp, main-template.php, _group.scss, 
 * Dependency to: ACF Page Builder custom
*/

const activateTabChildInstance = (tabChild) => {
    let ct = 0;
    var instance = tabChild;
    while(ct == 0) {
        instance.classList.add("active");
        instance = instance.nextElementSibling;
        if(instance && instance.getAttribute("tab-child") || !instance){
            ct++;
        }
    }
};

const tabOpen = (el, group, tab) => {
    let parentGroup = document.querySelector(`.group.tabulated[tab-group="${group}"]`);
    let tabChild = document.querySelector(`[tab-child="${group}-${tab}"]`);
    
    parentGroup.querySelectorAll("[tab-title]").forEach((tabChild) => {
        tabChild.classList.remove("active");
    });
    parentGroup.querySelectorAll(".tabs-container .tab").forEach((tab) => {
        tab.classList.remove("active");
    });
    
    let tabTrue = document.querySelector(`.tab[tab-id="${group}-${tab}"]`);
    tabTrue.classList.add("active");

    activateTabChildInstance(tabChild);
};

(function($){

    $(document).on("ready",function(){
        var gTabs = document.querySelectorAll(".group.tabulated");

        if(gTabs.length){
            gTabs.forEach((gTab,index) => {
                gTab.setAttribute("tab-group", index);
                var tabsContainer = document.createElement("div");
                tabsContainer.classList.add("tabs-container"); 

                let parentIndex = index;
                Array.from(gTab.children).forEach((childTab, index) => {
                    let tabInstance = parseInt(childTab.getAttribute("tab-instance"));
                    if(index == 0){
                        tabInstance = 1;
                    }
                    if(tabInstance == 1){
                        let tabTitle = childTab.getAttribute("tab-title");
                        let tabCssId = childTab.getAttribute("tab-css-id");
                        let newTab = document.createElement("div");
                        let titleH = document.createElement("h3");
                        titleH.innerHTML = tabTitle;
    
                        childTab.setAttribute("tab-child", `${parentIndex}-${index}`);
                        titleH.setAttribute("onclick",`tabOpen(this, ${parentIndex}, ${index})`);
                        newTab.setAttribute("tab-id",`${parentIndex}-${index}`);
                        tabCssId && newTab.setAttribute("id", `tab-css-id-${tabCssId}`);

                        newTab.append(titleH);
                        newTab.classList.add("tab");
                        if(index == 0){
                            newTab.classList.add("active");
                        }
                        tabsContainer.append(newTab);
                    }
                });

                activateTabChildInstance(Array.from(gTab.children)[0]);
                gTab.prepend(tabsContainer);
            });
        }
    });

})(jQuery);